import React, { Component as Component } from 'react';

export default class Modal extends Component {

	componentDidMount() {
		var { show, hide } = this.props;

		$(document).on(show, this.show);
		$(document).on(hide, this.hide);
	}

	componentWillUnmount() {
		var { show, hide } = this.props;

		$(document).off(show, this.show);
		$(document).off(hide, this.hide);
	}

	hide = () => {
		$(this.modal).modal('hide');
	}

	show = () => {
		$(this.modal).modal('show');
	}

	render() {
		return <div>
			<div className={ "modal fade " + this.props.className } ref={(modal) => { this.modal = modal; } } tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						{ this.props.children }
					</div>
				</div>
			</div>
		</div>
	}
}


// WEBPACK FOOTER //
// ./src/modules/utils/Modal.js